import {NgClass, NgTemplateOutlet} from '@angular/common';
import { Component, Input } from '@angular/core';
import { Router } from '@angular/router';
import { ButtonModule } from 'primeng/button';
import { TranslateModule } from '@ngx-translate/core';
import {AuthReturnUrlService} from '../../../core/services/auth-return-url.service';

@Component({
  selector: 'app-public-auth-cta',
  standalone: true,
  imports: [
    NgClass,
    NgTemplateOutlet,
    ButtonModule,
    TranslateModule
  ],
  templateUrl: './public-auth-cta.component.html',
  styleUrl: './public-auth-cta.component.scss'
})
export class PublicAuthCtaComponent {
  @Input() public compact: boolean = false;
  @Input() public titleKey = 'shared.public_auth_cta.title';
  @Input() public descriptionKey = 'shared.public_auth_cta.description';
  @Input() public registrationPrimary = false;
  @Input() public returnUrl: string | null = null;

  constructor(
    private readonly router: Router,
    private readonly returnUrls: AuthReturnUrlService,
  ) {
  }

  public goToLogin(): void {
    const returnUrl = this.returnUrl || this.router.url;
    this.returnUrls.remember(returnUrl);
    this.router.navigate(['/login'], {
      queryParams: {
        returnUrl
      }
    });
  }

  public goToRegister(): void {
    const returnUrl = this.returnUrl || this.router.url;
    this.returnUrls.remember(returnUrl);
    this.router.navigate(['/registration'], {
      queryParams: {
        returnUrl
      }
    });
  }
}
